import React from 'react';
// import { Link } from 'react-router-dom';
import { colors, typography } from '../styles/StyleGuide';
import visahkhaPdf from '../assets/files/Visahkha_committee.pdf';
import scientificPdf from '../assets/files/Scientific_committee.pdf';
import medicalDevicePdf from '../assets/files/Medical_device.pdf';
import ethicsPdf from '../assets/files/Ethics_committee_members.pdf';
import collegeCouncilPdf from '../assets/files/College_council.pdf';
import medicalEducationPdf from '../assets/files/Medical_Education_Unit.pdf';
import curriculumPdf from '../assets/files/Curriculum_committee.pdf';
import pharmacovigilancePdf from '../assets/files/PHARMACOVIGILANCE_committee.pdf';
import internalComplaintPdf from '../assets/files/Internal complaint committee.pdf';
import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '../config/site';

function Committees() {
  const committees = [
    {
      id: 'visahkha',
      title: "Visahkha Committee",
      description: "The Visahkha Committee oversees student activities, cultural events, and extracurricular programs. We promote holistic development and ensure student engagement in various institutional activities.",
      icon: "fas fa-star",
      color: colors.primary,
      pdfFile: visahkhaPdf
    },
    {
      id: 'scientific',
      title: "Scientific Committee", 
      description: "The Scientific Committee manages research activities, scientific publications, and academic conferences. We coordinate research projects and promote scientific excellence in medical education.",
      icon: "fas fa-microscope",
      color: colors.secondary,
      pdfFile: scientificPdf
    },
    {
      id: 'medical-device',
      title: "Medical Device Adverse Event Monitoring Committee",
      description: "The Medical Device Adverse Event Monitoring Committee ensures patient safety by monitoring and reporting adverse events related to medical devices. We maintain quality standards and safety protocols.",
      icon: "fas fa-shield-alt",
      color: colors.danger,
      pdfFile: medicalDevicePdf
    },
    {
      id: 'ethics',
      title: "Ethics Committee",
      description: "The Ethics Committee oversees research ethics, patient rights, and ethical standards in medical practice. We ensure compliance with ethical guidelines and protect patient interests.",
      icon: "fas fa-balance-scale",
      color: colors.success,
      pdfFile: ethicsPdf
    },
    {
      id: 'college-council',
      title: "College Council",
      description: "The College Council is the highest governing body that oversees institutional policies, strategic planning, and overall administration. We ensure effective governance and institutional development.",
      icon: "fas fa-building",
      color: colors.info,
      pdfFile: collegeCouncilPdf
    },
    {
      id: 'medical-education-unit',
      title: "Medical Education Unit",
      description: "The Medical Education Unit is responsible for faculty development, curriculum planning, and educational quality assurance. We ensure excellence in medical education through continuous improvement and innovation.",
      icon: "fas fa-graduation-cap",
      color: colors.warning,
      pdfFile: medicalEducationPdf
    },
    {
      id: 'curriculum-committee',
      title: "Curriculum Committee",
      description: "The Curriculum Committee oversees the development, review, and implementation of academic curricula. We ensure that our educational programs meet national standards and prepare students for medical practice.",
      icon: "fas fa-book-open",
      color: colors.dark,
      pdfFile: curriculumPdf,
      hasBorder: true
    },
    {
      id: 'pharmacovigilance-committee',
      title: "Pharmacovigilance Committee",
      description: "The Pharmacovigilance Committee monitors and evaluates drug safety, adverse drug reactions, and medication-related issues. We ensure patient safety through systematic monitoring and reporting of pharmaceutical events.",
      icon: "fas fa-pills",
      color: colors.danger,
      pdfFile: pharmacovigilancePdf
    },
    {
      id: 'internal-complaint-committee',
      title: "Internal Complaint Committee",
      description: "The Internal Complaint Committee addresses complaints related to workplace conduct and ensures a safe, respectful, and inclusive institutional environment through fair review and due process.",
      icon: "fas fa-user-shield",
      color: colors.secondary,
      pdfFile: internalComplaintPdf
    }
  ];

  const handlePdfDownload = (committee) => {
    window.open(committee.pdfFile, '_blank');
  };

  return (
    <div className="container py-5">
      <Helmet>
        <title>Committees | ACSR GMC Nellore</title>
        <meta name="description" content="Committees at A.C.S.R Government Medical College, Nellore, including Visahkha, Scientific, Medical Device, Ethics, College Council, Medical Education Unit, Curriculum, and Pharmacovigilance." />
        <link rel="canonical" href={`${SITE_URL}/committees`} />
      </Helmet>
      <div className="row">
        <div className="col-12">
          <h1 style={{
            color: colors.primary,
            fontSize: typography.fontSizes.xxl,
            fontWeight: typography.fontWeights.bold,
            textAlign: 'center',
            marginBottom: '3rem'
          }}>
            Committees
          </h1>
          
          <p style={{
            color: colors.textSecondary,
            fontSize: typography.fontSizes.lg,
            textAlign: 'center',
            marginBottom: '4rem',
            lineHeight: typography.lineHeights.relaxed
          }}>
            Various committees work together to ensure the smooth functioning and continuous improvement of our institution.
          </p>

          <div className="row">
            {committees.map((committee, index) => (
              <div key={index} className="col-lg-4 col-md-6 col-12 mb-4">
                <div style={{
                  backgroundColor: colors.white,
                  borderRadius: '15px',
                  padding: '2.5rem 2rem',
                  height: '100%',
                  border: committee.hasBorder ? `4px solid ${colors.primary}` : `3px solid ${committee.color}`,
                  cursor: 'pointer',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: committee.hasBorder ? `0 4px 15px rgba(0,0,0,0.1)` : 'none'
                }}>
                    
                    {/* Icon */}
                    <div style={{
                      textAlign: 'center',
                      marginBottom: '1.5rem'
                    }}>
                      <i 
                        className={committee.icon}
                        style={{
                          fontSize: '3rem',
                          color: committee.color
                        }}
                      ></i>
                    </div>

                    {/* Title */}
                    <h3 style={{
                      color: committee.color,
                      fontSize: typography.fontSizes.xl,
                      fontWeight: typography.fontWeights.bold,
                      textAlign: 'center',
                      marginBottom: '1rem'
                    }}>
                      {committee.title}
                    </h3>
                    
                    {/* Description */}
                    <p style={{
                      color: colors.textSecondary,
                      fontSize: typography.fontSizes.md,
                      lineHeight: typography.lineHeights.relaxed,
                      textAlign: 'center',
                      marginBottom: '1.5rem'
                    }}>
                      {committee.description}
                    </p>

                    {/* View PDF Button */}
                    <div style={{
                      textAlign: 'center'
                    }}>
                      <button
                        onClick={() => handlePdfDownload(committee)}
                        style={{
                          backgroundColor: colors.info,
                          color: colors.white,
                          border: 'none',
                          borderRadius: '8px',
                          padding: '0.75rem 1.5rem',
                          fontSize: typography.fontSizes.md,
                          fontWeight: typography.fontWeights.medium,
                          cursor: 'pointer',
                          minWidth: '120px',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => {
                          e.target.style.opacity = '0.8';
                          e.target.style.transform = 'translateY(-2px)';
                        }}
                        onMouseOut={(e) => {
                          e.target.style.opacity = '1';
                          e.target.style.transform = 'translateY(0)';
                        }}
                      >
                        <i className="fas fa-file-pdf me-2"></i>
                        View PDF
                      </button>
                    </div>
                  </div>
              </div>
            ))}
          </div>

          {/* Additional Information */}
          <div className="row mt-5">
            <div className="col-12">
              <div style={{
                backgroundColor: colors.primaryLight,
                borderRadius: '12px',
                padding: '2rem',
                border: `2px solid ${colors.primary}`
              }}>
                <h4 style={{
                  color: colors.primary,
                  fontSize: typography.fontSizes.lg,
                  fontWeight: typography.fontWeights.semiBold,
                  marginBottom: '1rem'
                }}>
                  Committee Information
                </h4>
                <p style={{
                  color: colors.textSecondary,
                  fontSize: typography.fontSizes.md,
                  lineHeight: typography.lineHeights.relaxed,
                  marginBottom: '0'
                }}>
                  All committees operate under the guidance of the college administration and follow established protocols. 
                  Click on any committee to download the related PDF document directly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Committees; 
